import React from 'react';
import Card from 'components/ui/card/Card';
import Loader from './Loader';
import styled from 'styled-components';

const StyledLoadingWrapper = styled(Card)`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none !important;
    background: none !important;
    height: 80vh;

    @media (min-width: 786px) {
        height: 78vh;
    }
`;

const LoadingCard = () => {
    return (
        <StyledLoadingWrapper>
            <Loader />
        </StyledLoadingWrapper>
    );
};

export default LoadingCard;



// WEBPACK FOOTER //
// ./src/components/loading/LoadingCard.js